export const allowYandexMetrikaCounter = process.env.NODE_ENV !== 'development';
export const allowGoogleTagManager = process.env.NODE_ENV !== 'development';
export const allowFreshChat = process.env.NODE_ENV !== 'development';

export const AUTH_COOKIE_NAME = 'AuthToken';
export const GUEST_ID_COOKIE_NAME = 'GuestId';
export const SELECTED_LANGUAGE = 'SelectedLanguage';

const SSR_LOOP_MAX_ITERATIONS_FALLBACK = 3;

export const SSR_LOOP_MAX_ITERATIONS = (() => {
  const value = parseInt(process.env.SSR_LOOP_MAX_ITERATIONS as string);

  if (Number.isNaN(value)) {
    return SSR_LOOP_MAX_ITERATIONS_FALLBACK;
  }

  return value;
})();

